(() => {
  window.__sleepyV4Measurement?.destroy?.();
  const controller = new AbortController();
  const signal = controller.signal;
  const pendingVariants = new WeakMap();
  let privacyRequested = false;
  const validHandle = value => /^[a-z0-9][a-z0-9_-]{0,199}$/i.test(value || '');
  const publicRoute = value => {
    try {
      const url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin) return null;
      const parts = url.pathname.split('/').filter(Boolean);
      if (/^[a-z]{2}(?:-[a-z]{2})?$/i.test(parts[0] || '')) parts.shift();
      if (!parts.length) return '/';
      if (['cart', 'search'].includes(parts[0]) && parts.length === 1) return '/' + parts[0];
      if (parts[0] === 'collections' && parts[2] === 'products' && parts.length === 4 && validHandle(parts[3])) return '/products/' + parts[3];
      if (['products', 'collections', 'pages', 'policies'].includes(parts[0]) && parts.length === 2 && validHandle(parts[1])) return '/' + parts.join('/');
      if (parts[0] === 'blogs' && parts.length <= 3 && parts.slice(1).every(validHandle)) return '/' + parts.join('/');
    } catch {}
    return null;
  };
  const ensurePrivacy = () => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed || privacyRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
    } catch {}
  };
  const allowed = () => {
    ensurePrivacy();
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch { return false; }
  };
  const emit = (event, fields = {}) => {
    if (!allowed()) return;
    const entry = { event, route: publicRoute(window.location.href) || '/other', ...fields };
    try {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.dataLayer.push === 'function') window.dataLayer.push(entry);
    } catch {}
  };
  const labelFor = (link, route) => {
    const labels = {
      '/': 'Home', '/cart': 'Cart', '/search': 'Search',
      '/collections/mattresses': 'Mattresses', '/collections/bamboo-bliss': 'Bamboo Bliss mattresses',
      '/collections/bed-bundles': 'Mattress + base', '/collections/bed-bases': 'Bed bases',
      '/collections/bed-frames': 'Bed frames', '/pages/contact': 'Contact', '/pages/our-story': 'Our story'
    };
    const knownLabels = ['Shop mattresses', 'Shop bundles', 'Choose Medium Soft', 'Choose Medium Firm', 'Compare both', 'Read customer reviews'];
    const text = link.textContent?.trim().replace(/\s+/g, ' ');
    return knownLabels.find(label => label.toLowerCase() === text?.toLowerCase()) || labels[route] || route.split('/').filter(Boolean).at(-1).replace(/[-_]/g, ' ');
  };
  const isShowroom = target => {
    if (target.hasAttribute('data-sc-showroom')) return true;
    const text = target.textContent?.trim().replace(/\s+/g, ' ') || '';
    if (/^(?:book|arrange|request) (?:a |your )?showroom visit$/i.test(text) || /^visit (?:our |the )?showroom$/i.test(text)) return true;
    try {
      const url = new URL(target.getAttribute('href') || '', window.location.href);
      return /^(?:maps\.app\.goo\.gl|maps\.google\.[a-z.]+|(?:www\.)?waze\.com)$/.test(url.hostname) || /^(?:www\.)?google\.[a-z.]+$/.test(url.hostname) && url.pathname.startsWith('/maps') || url.hostname === 'goo.gl' && url.pathname.startsWith('/maps');
    } catch { return false; }
  };
  document.addEventListener('click', event => {
    if (event.isTrusted === false || event.defaultPrevented || event.button > 0) return;
    const target = event.target.closest?.('a,button');
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    const href = target.getAttribute('href') || '';
    if (/^tel:/i.test(href)) {
      emit('sc_call_click', { navigation_label: 'Call' });
      return;
    }
    if (isShowroom(target)) {
      emit('sc_showroom_click', { navigation_label: 'Showroom visit or directions' });
      return;
    }
    if (target.tagName !== 'A' || !href || href.startsWith('#')) return;
    const destination = publicRoute(href);
    if (destination) emit('sc_navigation', { destination_route: destination, navigation_label: labelFor(target, destination) });
  }, { capture: true, signal });
  document.addEventListener('change', event => {
    if (event.isTrusted === false) return;
    if (!event.target.closest?.('variant-picker')) return;
    const info = event.target.closest('product-info');
    if (!info) return;
    const form = document.getElementById(info.getAttribute('form'));
    pendingVariants.set(info, String(form?.querySelector('input[name="id"]')?.value || ''));
  }, { capture: true, signal });
  document.addEventListener('variant:change', event => {
    const info = event.target.closest?.('product-info');
    if (!info || !pendingVariants.has(info)) return;
    const previous = pendingVariants.get(info);
    pendingVariants.delete(info);
    const variant = event.detail?.variant || event.detail?.data?.variant;
    const id = typeof variant?.id === 'number' || typeof variant?.id === 'string' ? String(variant.id) : '';
    const route = publicRoute(info.getAttribute('data-product-url'));
    if (!/^\d{1,20}$/.test(id) || id === previous || !route?.startsWith('/products/')) return;
    emit('sc_variant_select', { product_handle: route.slice('/products/'.length), variant_id: id });
  }, { capture: true, signal });
  document.addEventListener('visitorConsentCollected', ensurePrivacy, { signal });
  window.addEventListener('load', ensurePrivacy, { once: true, signal });
  window.__sleepyV4Measurement = { destroy: () => controller.abort() };
  ensurePrivacy();
})();
